"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { getImageUrl } from "@/utils/utils";
import RichContent from "@/components/ui/RichContent";

interface SustainabilityDetailClientProps {
  sustainabilityDetail: any;
}

const SustainabilityDetailClient: React.FC<SustainabilityDetailClientProps> = ({
  sustainabilityDetail,
}) => {
  // Animation variants
  const sectionVariants = {
    hidden: {
      opacity: 0,
      y: 60,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "circOut" as const,
      },
    },
  };

  return (
    <motion.div
      className="bg-[#f4f5f6] py-12 sm:py-16 lg:py-[100px]"
      initial="hidden"
      animate="visible"
      variants={sectionVariants}
    >
      <div className="mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center gap-4 lg:gap-[17px] mb-8 sm:mb-12 lg:mb-[50px]">
          <motion.h2
            className="text-[#0a1119] text-center text-2xl sm:text-3xl lg:text-[40px] font-medium leading-tight lg:leading-[58px] lg:tracking-[-1.44px]"
            initial="hidden"
            animate="visible"
          >
            {sustainabilityDetail?.sustainability?.title || ""}
          </motion.h2>
          <div className="w-[50px] h-[2px] bg-[#1a5852]"></div>
        </div>

        {/* Sustainability Details */}
        <div className="bg-white relative overflow-hidden rounded-lg lg:rounded-none shadow-[0_30px_60px_0_rgba(0,0,0,0.08)]">
          <div className="relative p-8 lg:p-[50px]">
            {/* Description */}
            <motion.div
              className="flex flex-col gap-3 md:gap-5 text-[#3d434c] text-lg sm:text-xl lg:text-[20px] font-normal leading-relaxed lg:leading-8"
              initial="hidden"
              animate="visible"
            >
              <RichContent
                html={sustainabilityDetail?.sustainability?.description}
                className="mt-[-20px] text-justify text-base"
              />

              {sustainabilityDetail?.sustainability?.image && (
                <Image
                  src={getImageUrl(
                    sustainabilityDetail?.sustainability?.image?.url || ""
                  )}
                  alt={
                    sustainabilityDetail?.sustainability?.image
                      ?.alternativeText ||
                    `${sustainabilityDetail?.sustainability?.title} Figure`
                  }
                  width={6000}
                  height={6000}
                  className="w-full h-auto"
                />
              )}
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SustainabilityDetailClient;
